import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/**
 * Форматирует ISO-дату в вид: "DD-MMM-YYYY"
 * Пример: "2025-07-15T23:59:59.000000Z" → "15-JUL-2025"
 */
export function formatEndDate(isoDate: string | Date): string {
  return dayjs.utc(isoDate).format('DD-MMM-YYYY').toUpperCase();
}
